import { API_BASE_URL } from "../config/apiBaseUrl.js";

async function parseResponse(response) {
  let body = null;

  try {
    body = await response.json();
  } catch {
    body = null;
  }

  if (!response.ok) {
    const error = new Error(body?.message || "Unable to process request.");
    error.status = response.status;
    error.body = body;
    throw error;
  }

  return body;
}

export async function requestPasswordReset(email) {
  const response = await fetch(`${API_BASE_URL}/api/auth/password-reset/request`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email }),
  });

  return parseResponse(response);
}

export async function validatePasswordResetToken(token) {
  const params = new URLSearchParams({ token });
  const response = await fetch(
    `${API_BASE_URL}/api/auth/password-reset/validate?${params}`,
    { credentials: "include" }
  );

  return parseResponse(response);
}

export async function confirmPasswordReset(token, password) {
  const response = await fetch(`${API_BASE_URL}/api/auth/password-reset/confirm`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ token, password }),
  });

  return parseResponse(response);
}

export async function validateInvitationToken(token) {
  const params = new URLSearchParams({ token });
  const response = await fetch(
    `${API_BASE_URL}/api/auth/invitation/validate?${params}`,
    { credentials: "include" }
  );

  return parseResponse(response);
}

export async function acceptInvitation(token, password) {
  const response = await fetch(`${API_BASE_URL}/api/auth/invitation/accept`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ token, password }),
  });

  return parseResponse(response);
}
